/**
* 风控首页 管理员使用
*/
<template>
	<div style="display: flex;flex-direction: column; height: 92vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div
			style="margin-bottom: 10px; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05); border: 1px solid #ebeef5; background: #fff; flex-shrink: 0;">


			<div @click="showSearch = !showSearch"
				style="display: flex; align-items: center; justify-content: space-between; padding: 12px 20px; background: #fafafa; border-bottom: 1px solid #f0f2f5; cursor: pointer; user-select: none;">
				<div style="display: flex; align-items: center;">
					<div style="width: 4px; height: 14px; background: #67C23A; border-radius: 2px; margin-right: 8px;">
					</div>
					<span style="font-size: 13px; font-weight: bold; color: #606266;">
						<!-- 条件筛选查询 -->
						{{ $t('language000472') }}
					</span>
					<i :class="showSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
						style="margin-left: 8px; color: #909399; font-size: 12px;"></i>
				</div>
				<!-- // '收起搜索项' // '展开搜索项' -->
				<div style="font-size: 11px; color: #999;">
					{{ showSearch ? $t('language000473') : $t('language000473') }}
				</div>
			</div>


			<el-collapse-transition>
				<div v-show="showSearch" style="padding: 16px 20px; background: #ffffff;">

					<!-- 搜索条件 -->
					<el-form :inline="true" size="mini" label-position="left" style="margin-bottom: -10px;">

						<!-- 日期搜索 -->
						<el-form-item :label="$t('language000475')" style="margin-bottom: 12px; margin-right: 20px;">
							<el-date-picker v-model="value" type="daterange" @change="selectTime"
								:start-placeholder="$t('language000292')" :end-placeholder="$t('language000293')"
								:default-time="['00:00:00', '23:59:59']" style="width: 240px; border-radius: 4px;">
							</el-date-picker>
						</el-form-item>

						<!-- 设备ID -->
						<el-form-item :label="$t('language000294')" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input :placeholder="$t('language000294')" v-model="input2" style="width: 240px;"
								clearable></el-input>
						</el-form-item>

						<!-- 用户ID -->
						<el-form-item :label="$t('language000095')" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input :placeholder="$t('language000095')" v-model="input3" style="width: 240px;"
								clearable></el-input>
						</el-form-item>

						<!-- 昵称 -->
						<el-form-item :label="$t('language000476')" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input :placeholder="$t('language000476')" v-model="input4" style="width: 240px;"
								clearable></el-input>
						</el-form-item>

						<el-form-item style="margin-bottom: 12px; margin-left: auto; float: right;">
							<el-button type="primary" icon="el-icon-search" @click="search()"
								style="box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);">
								<!-- 查询 -->
								{{ $t('language000477') }}
							</el-button>
							<el-button icon="el-icon-refresh-right" @click="reset()">
								<!-- 重置 -->
								{{ $t('language000478') }}
							</el-button>
						</el-form-item>
						<div style="clear: both;"></div>


					</el-form>
				</div>
			</el-collapse-transition>
		</div>


		<!-- 列表 -->
		<el-table :data="tableData" height="100%" stripe border :header-cell-style="{ 
		        background: '#f8f9fa', 
		        color: '#303133', 
		        fontWeight: 'bold', 
		        fontSize: '14px',
		        height: '50px'
		    }" :cell-style="{ fontSize: '14px', color: '#606266', padding: '12px 0' }"
			style="width: 100%; flex: 1; border-radius: 4px;"
			:default-sort="{ prop: 'loginTime', order: 'descending' }">

			<!-- 序号 -->
			<el-table-column type="index" :index="indexMethod" :label="$t('language000479')" width="60"
				align="center"></el-table-column>

			<!-- 登录记录 / 序列号 -->
			<el-table-column :label="$t('language000480')" min-width="190">
				<template slot-scope="scope">
					<div style="color: #303133;">{{ scope.row.loginTime }}</div>
					<div
						style="font-family: Consolas, Monaco, monospace; font-size: 12px; color: #909399; word-break: break-all;">
						<!-- 序列号: -->
						{{ $t('language000481') }}
						{{ scope.row.sequenceId }}
					</div>
				</template>
			</el-table-column>

			<!-- 用户信息 -->
			<el-table-column :label="$t('language000093')" width="180">
				<template slot-scope="scope">
					<div style="display: flex; flex-direction: column; gap: 4px; padding: 4px 0;">

						<div style="display: flex; align-items: center; gap: 8px;">
							<span
								:style="{ fontSize: '13px',  fontWeight: '600',  color: scope.row.nickName ? '#303133' : '#C0C4CC',  maxWidth: '100px',overflow: 'hidden', textOverflow: 'ellipsis',  whiteSpace: 'nowrap' }">
								{{ scope.row.nickName || '未命名' }}
							</span>

							<el-tag :type="getGenderTagType(scope.row.sex)" size="mini" effect="light"
								style="border-radius: 4px; border: none; font-weight: 500;"
								:style="getGenderCustomStyle(scope.row.sex)">
								{{ genderMap[scope.row.sex] || '未知' }}
							</el-tag>
						</div>

						<div style="display: flex; align-items: center; font-size: 12px; color: #909399;">
							<span
								style="background: #F2F6FC; padding: 0 4px; border-radius: 2px; margin-right: 6px; font-size: 10px; transform: scale(0.9);">ID</span>
							<span style="font-family: Monaco, Consolas, monospace; letter-spacing: 0.5px;">
								{{ scope.row.userId }}
							</span>
						</div>

					</div>
				</template>
			</el-table-column>

			<!-- 设备ID -->
			<el-table-column :label="$t('language000294')" prop="deviceId" width="180">
				<template slot-scope="scope">
					<span
						style="font-family: Consolas, Monaco, monospace; font-size: 12px;">{{ scope.row.deviceId }}</span>
				</template>
			</el-table-column>

			<!-- 终端设备 -->
			<el-table-column :label="$t('language000482')" width="140" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center; justify-content: center; gap: 2px;">

						<div v-if="scope.row.deviceOs"
							style="display: flex; align-items: center; justify-content: center;">
							<svg v-if="scope.row.deviceOs && scope.row.deviceOs.toLowerCase().includes('ios')"
								viewBox="0 0 1024 1024" width="16" height="16" style="vertical-align: middle;">
								<path
									d="M720.2 461c-1.4-101.1 82.8-149.7 86.6-152.1-47.1-68.9-120.4-78.3-146.5-79.4-62.5-6.4-121.9 36.8-153.6 36.8-31.7 0-80.4-36-132.5-35-68.5 1-131.6 39.9-166.8 101.1-71.2 123.6-18.2 306.7 50.8 406.4 33.8 48.8 74.1 103.6 126.9 101.7 50.8-1.9 70-32.7 131.4-32.7 61.3 0 78.5 32.7 132.5 31.7 55-1 91.4-49.8 125-98.6 38.7-56.3 54.7-110.8 55.6-113.7-1.3-0.4-107.5-41.2-109.4-165.2z"
									fill="none" stroke="#606266" stroke-width="50" stroke-linejoin="round"></path>
								<path
									d="M616.4 205.1c28-33.9 46.9-81 41.7-128.1-40.4 1.6-89.4 26.9-118.4 60.8-26 30.1-48.8 78.7-42.7 124.5 45.2 3.5 91.4-23.3 119.4-57.2z"
									fill="none" stroke="#606266" stroke-width="50" stroke-linejoin="round"></path>
							</svg>

							<svg v-else-if="scope.row.deviceOs && scope.row.deviceOs.toLowerCase().includes('android')"
								viewBox="0 0 1024 1024" width="17" height="17">
								<path
									d="M704 64H320c-53 0-96 43-96 96v704c0 53 43 96 96 96h384c53 0 96-43 96-96V160c0-53-43-96-96-96zM320 128h384c17.7 0 32 14.3 32 32v48H288v-48c0-17.7 14.3-32 32-32z m384 768H320c-17.7 0-32-14.3-32-32v-48h448v48c0 17.7-14.3 32-32 32z m32-144H288V272h448v480z"
									fill="#A4C639"></path>
							</svg>

							<i v-else class="el-icon-mobile-phone" style="color: #909399;"></i>
						</div>


						<div style="display: flex; align-items: center; white-space: nowrap;">
							<span v-if="scope.row.brand" style="font-size: 12px; color: #909399; font-weight: 400;">
								{{ scope.row.brand }}
							</span>
							<span v-else style="color: #C0C4CC; font-size: 12px;">
								<!-- 未知设备 -->
								{{ $t('language000483') }}
							</span>
						</div>
					</div>
				</template>
			</el-table-column>

			<!-- 风险评估 (网易/AI) -->
			<el-table-column :label="$t('language000484')" width="200" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center; justify-content: center; gap: 6px;">
						<span :style="{ 
						    fontSize: '13px', 
						    fontWeight: '500',
						    /* 逻辑：风险越高，颜色越亮、越深 */
						    color: scope.row.riskLevel === '3' ? '#F56C6C' :           // 红色 (警示)
						          (scope.row.riskLevel === '2' ? '#E6A23C' :           // 橙色 (注意)
						          (scope.row.riskLevel === '1' ? '#409EFF' :           // 蓝色 (提示：比正常更明显)
						          (scope.row.riskLevel === '0' ? '#C0C4CC' : '#909399'))) // 浅灰色 (忽略：最不显眼)
						}">
							{{ scope.row.riskLevelText }}
						</span>

						<span style="color: #EBEEF5;">|</span>

						<el-tag size="mini" :type="getType(scope.row.aiRiskLevel)" effect="plain"
							style="border: none; padding: 0; background: transparent; font-weight: bold; font-size: 13px;">
							<i :class="getIcon(scope.row.aiRiskLevel)" style="margin-right: 2px;"></i>
							{{ getText(scope.row.aiRiskLevel) }}
						</el-tag>
					</div>
				</template>
			</el-table-column>

			<!-- 状态 / 白名单 -->
			<el-table-column :label="$t('language000485')" width="200" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center; justify-content: center; gap: 8px;">

						<span :style="{ 
			                fontSize: '12px',
			                fontWeight: scope.row.status === '0' ? '400' : '600',
			                color: {
			                    '0': '#C0C4CC',     // 浅灰  正常
			                    '1': '#E6A23C',     // 橙色 禁言
								'2': '#F56C6C',   // 红色 被封禁
								'3': '#F56C6C', // 红色 禁止登录
								'4': '#AF292E',  // 深红
								'-3': '#909399', // 中灰 自己注销
			                   '-2': '#909399', // 中灰 自动封号
			                }[scope.row.status] || '#909399'
			            }">
							{{ scope.row.statusText }}
						</span>

						<span style="color: #EBEEF5;">|</span>

						<span :style="{
						    fontSize: '12px',
						    padding: '2px 6px',
						    borderRadius: '4px',
						    whiteSpace: 'nowrap',
						    /* 1 (是): 绿底绿字有边框，非常显眼 */
						    background: scope.row.isWhiteList === 1 ? '#F0F9EB' : 'transparent',
						    /* 0 (否): 使用 #C0C4CC，确保和账号状态的‘正常’颜色完全对齐 */
						    color: scope.row.isWhiteList === 1 ? '#67C23A' : '#C0C4CC', 
						    border: scope.row.isWhiteList === 1 ? '1px solid #E1F3D8' : '1px solid transparent',
						    /* ‘否’的时候不需要加粗，‘是’的时候可以加粗增强对比 */
						    fontWeight: scope.row.isWhiteList === 1 ? '600' : '400'
						}">
							<!-- 是：否 -->
							{{ scope.row.isWhiteList === 1 ? $t('language000267') : $t('language000268') }}
						</span>

					</div>
				</template>
			</el-table-column>

			<!-- 网络地址 (IP/归属地) -->
			<el-table-column :label="$t('language000486')" min-width="200">
				<template slot-scope="scope">
					<div v-if="!scope.row.ip" style="color: #C0C4CC; font-size: 13px;">
						<!-- 无 -->
						{{ $t('language000487') }}
					</div>
					<div
						style="font-family: Consolas, Monaco, monospace; font-size: 14px; font-weight: 400; color: #3f4043;">
						{{ scope.row.ip }}
					</div>
					<div style="font-size: 12px; color: #909399; margin-top: 2px;">
						<i class="el-icon-location-outline"></i>
						<span v-if="scope.row.address">{{ scope.row.address }}</span>
						<span v-else style="color: #DCDFE6;">
							<!-- 位置未知 -->
							{{ $t('language000488') }}
						</span>
					</div>
				</template>
			</el-table-column>


			<!-- 操作 -->
			<el-table-column fixed="right" :label="$t('language000086')" width="100" align="center">
				<template slot-scope="scope">

					<!-- 正常用户 (status === 0) -> 可以封号，可以禁言 -->
					<template v-if="scope.row.status === 0">

						<div
							style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; width: 100%;">
							<!-- 确定要封禁该用户吗？  -->
							<el-popconfirm :title="$t('language000491')" @confirm="confirmUpdateStatus(scope.row, 2)">
								<el-button slot="reference" type="text" size="small"
									style="color: #EF4444; font-weight: bold; padding: 2px 0;">
									<!-- 封号 -->
									{{ $t('language000489') }}
								</el-button>
							</el-popconfirm>

							<!-- 确定要禁言该用户吗？ -->
							<el-popconfirm :title="$t('language000525')" @confirm="confirmUpdateStatus(scope.row, 1)">
								<el-button slot="reference" type="text" size="small"
									style="color: #E6A23C; font-weight: bold; padding: 2px 0;">
									<!-- 禁言  -->
									{{ $t('language000497') }}
								</el-button>
							</el-popconfirm>
						</div>

					</template>

					<!-- 禁言用户 (status === 1) -> 可以解禁，可以封号 -->
					<template v-else-if="scope.row.status === 1">

						<div
							style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; width: 100%;">
							<!-- 确定要封禁该用户吗？  -->
							<el-popconfirm :title="$t('language000491')" @confirm="confirmUpdateStatus(scope.row, 2)">
								<el-button slot="reference" type="text" size="small"
									style="color: #EF4444; font-weight: bold; padding: 2px 0;">
									<!-- 封号 -->
									{{ $t('language000489') }}
								</el-button>
							</el-popconfirm>

							<!-- 确定要解除禁言吗？ -->
							<el-popconfirm :title="$t('language000526')" @confirm="confirmUpdateStatus(scope.row, 3)">
								<el-button slot="reference" type="text" size="small"
									style="color: #67C23A; font-weight: bold; padding: 2px 0;">
									<!-- 解除禁言 -->
									{{ $t('language000527') }}
								</el-button>
							</el-popconfirm>
						</div>

					</template>


					<!-- 已封禁用户 (status === 2) -> 只能解封 -->
					<template v-else-if="scope.row.status === 2">
						<!-- 确定要解除封禁吗？  -->
						<el-popconfirm :title="$t('language000492')" @confirm="confirmUpdateStatus(scope.row, 0)">
							<el-button slot="reference" type="text" size="small"
								style="color: #409EFF; font-weight: bold; padding: 2px 0;">
								<!-- 解封 -->
								{{ $t('language000490') }}
							</el-button>
						</el-popconfirm>
					</template>

					<!-- 其他异常或不可操作状态（如注销、自动封禁等） -->
					<span v-else style="color: #909399; font-size: 13px;">
						{{ scope.row.statusText }}
					</span>

				</template>
			</el-table-column>


		</el-table>

		<!-- 页码 -->
		<div
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[50,100,200,400, 600,1000,2000,5000]" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		computed: {
			// 将 riskOptions 从 data 移动到 computed
			riskOptions() {
				return [{
						label: this.$t('language000493'), // 对应 "正常"
						value: '0',
						color: '#67C23A'
					},
					{
						label: this.$t('language000494'), // 对应 "低风险"
						value: '1',
						color: '#909399'
					},
					{
						label: this.$t('language000495'), // 对应 "中风险"
						value: '2',
						color: '#E6A23C'
					},
					{
						label: this.$t('language000496'), // 对应 "高风险"
						value: '3',
						color: '#F56C6C'
					}
				];
			}
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				showStats: false, // 统计面板状态
				showSearch: false, // 搜索面板状态
				value: '', //时间
				startTime: 0, //开始时间
				endTime: 0, //结束时间
				input1: '', //信息序号
				input2: '', //设备ID
				input3: '', //用户ID
				input4: '', //用户昵称
				input5: '', //用户手机号
				input6: '', //手机品牌
				input7: '', //IP地址
				input8: '', //IP所属地
				input9: '', //AI风控等级
				genderMap: {
					1: 'male',
					2: 'female',
					3: 'SISSY',
					4: 'MTF',
					5: 'FTM'
				},
				pageSize: 50, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //用户设备指纹信息列表
		},
		methods: {
			fetchData(pageNum, pageSize) { //用户设备指纹信息列表

				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.input1.length > 0) { //信息序号
					requestData.sequenceId = this.input1;
				}
				if (this.input2.length > 0) { //设备id 精确查询
					requestData.deviceId = this.input2;
				}
				if (this.input3.length > 0) { //用户id 精确查询
					requestData.userId = this.input3;
				}
				if (this.input4.length > 0) { //用户名称，模糊查询
					requestData.nickName = this.input4;
				}
				if (this.input5.length > 0) { //手机号码  精确查询
					requestData.phoneNumber = this.input5;
				}
				if (this.input6.length > 0) { //手机品牌  为空时默认查全部
					requestData.brand = this.input6;
				}
				if (this.input7.length > 0) { //IP地址
					requestData.ip = this.input7;
				}
				if (this.input8.length > 0) { //IP所属地
					requestData.address = this.input8;
				}
				if (this.input9.length > 0) { //AI风控等级
					requestData.aiRiskLevel = this.input9;
				}
				if (this.startTime > 0) { //开始时间
					requestData.startTime = this.startTime;
				}
				if (this.endTime > 0) { //结束时间
					requestData.endTime = this.endTime;
				}

				axios.post(this.$p_url + '/admin/getPageOfDeviceBasicInfoNetEasy', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							const resultData = response.data.data || {}; //安全获取 data 对象
							this.total = resultData.total || 0;
							const list = resultData.list || []; //防御性获取 list，如果 list 为空则赋值为空数组 []，避免 .length 报错

							for (let i = 0; i < list.length; i++) {
								let item = list[i]; // 定义一个 item 方便书写，不用每次都写一长串

								const statusMap = {
									0: "language000493", // 正常
									1: "language000497", // 禁言
									2: "language000498", // 被封禁
									3: "language000499", // 禁止登录
									4: "language000500", // 自动封号
									"-3": "language000501", // 自己注销
									"-2": "language000500" // 自动封号
								};

								const riskMap = {
									0: "language000493", // 正常
									1: "language000494", // 低风险
									2: "language000495", // 中风险
									3: "language000496", // 高风险
									4: "language000502" // 可信源
								};

								const sKey = statusMap[item.status];
								item.statusText = sKey ? this.$t(sKey) : item.status;

								const rKey = riskMap[item.riskLevel];
								item.riskLevelText = rKey ? this.$t(rKey) : item.riskLevel;
							}
							this.tableData = list; //最后赋值给表格
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			confirmUpdateStatus(row, targetStatus) { // 这里调用接口
				console.log(`正在请求接口：修改用户 ${row.userId} 的状态为 ${targetStatus}`);

				if (targetStatus == 2) {
					console.log("进行封号处理");
					this.loadingData = true;
					axios.get(this.$p_url + '/admin/black/' + row.userId, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("封禁账号 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (response.data.state === "success") {
								this.$message({
									message: '封禁成功',
									type: 'success',
									duration: 2000
								});
								this.fetchData(this.pageNum, this.pageSize); //刷新
							} else {
								// 处理业务级错误（如权限不足等）
								this.$message.error(response.data.message || "操作失败");
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert("请求失败：" + error);
						});
				} else if (targetStatus == 0) {
					console.log("进行解除处理");
					this.loadingData = true;
					axios.get(this.$p_url + '/admin/black/release/' + row.userId, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("解封账号 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (response.data.state === "success") {
								this.$message({
									message: '解封成功',
									type: 'success',
									duration: 2000
								});
								this.fetchData(this.pageNum, this.pageSize); //刷新
							} else {
								// 处理业务级错误（如权限不足等）
								this.$message.error(response.data.message || "操作失败");
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert("请求失败：" + error);
						});
				} else if (targetStatus == 1) {
					console.log("进行禁言处理");
					this.loadingData = true;
					axios.get(this.$p_url + '/admin/accountSilence/' + row.userId, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("禁言账号 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (response.data.state === "success") {
								this.$message({
									message: '禁言成功',
									type: 'success',
									duration: 2000
								});
								this.fetchData(this.pageNum, this.pageSize); //刷新
							} else {
								// 处理业务级错误（如权限不足等）
								this.$message.error(response.data.message || "操作失败");
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert("请求失败：" + error);
						});
				} else if (targetStatus == 3) {
					console.log("进行解除禁言处理");
					this.loadingData = true;
					axios.get(this.$p_url + '/admin/releaseAccountSilence/' + row.userId, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("解除禁言账号 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (response.data.state === "success") {
								this.$message({
									message: '解除禁言成功',
									type: 'success',
									duration: 2000
								});
								this.fetchData(this.pageNum, this.pageSize); //刷新
							} else {
								// 处理业务级错误（如权限不足等）
								this.$message.error(response.data.message || "操作失败");
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert("请求失败：" + error);
						});
				} else {

				}


			},
			handleClick() { //被封设备

				//不打开新的标签页面
				// this.$router.push({
				// 	path: '/WindControlBlackList',
				// 	query: {}
				// });

				//打开新的标签页面
				let page = this.$router.resolve({
					path: '/WindControlBlackList',
					query: {}
				});
				window.open(page.href, '_blank');
			},
			handleClickAccount() { //被封账号

				//不打开新的标签页面
				// this.$router.push({
				// 	path: '/WindControlBanList',
				// 	query: {}
				// });

				//打开新的标签页面
				let page = this.$router.resolve({
					path: '/WindControlBanList',
					query: {}
				});
				window.open(page.href, '_blank');

			},
			handleClickIp() { //IP被封详情
				let page = this.$router.resolve({
					path: '/WindControlIp',
					query: {}
				});
				window.open(page.href, '_blank');
			},
			toWhitelistList() { //白名单
				let page = this.$router.resolve({
					path: '/WhitelistList',
					query: {}
				});
				window.open(page.href, '_blank');
			},
			querySimCard(index) { //查看详情

				//不打开新的标签页面
				// this.$router.push({
				// 	path: '/WindControlInfo',
				// 	query: {
				// 		sequenceId: this.tableData[index].sequenceId,
				// 		userId: this.tableData[index].userId,
				// 	}
				// });

				//打开新的标签页面
				if (this.tableData[index].deviceOs == "Android") {
					let page = this.$router.resolve({
						path: '/WindControlInfo',
						query: {
							sequenceId: this.tableData[index].sequenceId,
							deviceId: this.tableData[index].deviceId,
							userId: this.tableData[index].userId,
							country: this.tableData[index].country,
							id: this.tableData[index].id,
							phoneNumber: this.tableData[index].phoneNumber,
							ip: this.tableData[index].ip,
						}
					});
					window.open(page.href, '_blank');
				} else {
					let page = this.$router.resolve({
						path: '/WindControlInfo01',
						query: {
							sequenceId: this.tableData[index].sequenceId,
							deviceId: this.tableData[index].deviceId,
							userId: this.tableData[index].userId,
							country: this.tableData[index].country,
							id: this.tableData[index].id,
							phoneNumber: this.tableData[index].phoneNumber,
							ip: this.tableData[index].ip,
						}
					});
					window.open(page.href, '_blank');
				}


			},
			reset() { //单击了重置
				this.startTime = 0; //开始时间
				this.endTime = 0; //结束时间
				this.input1 = ""; //信息序号
				this.input2 = ""; //设备ID
				this.input3 = ""; //用户ID
				this.input4 = ""; //用户昵称
				this.input5 = ""; //用户手机号
				this.input6 = ""; //手机品牌
				this.input7 = ""; //IP地址
				this.input8 = ""; //IP所属地
				this.input9 = ''; //AI风控等级

				this.fetchData(1, this.pageSize);
			},
			search() { //单击了搜索
				console.log('开始时间/结束时间', this.startTime + "/" + this.endTime);
				console.log('信息序号/设备ID/用户ID/ip', this.input1 + "/" + this.input2 + "/" + this.input3 + "/" + this.input7);
				console.log('用户昵称/用户手机号/手机品牌', this.input4 + "/" + this.input5 + "/" + this.input6);
				console.log('IP所属地/AI风控等级', this.input8 + "/" + this.input9);

				this.fetchData(1, this.pageSize);
			},
			selectTime() { //选择了时间
				if (this.value == null) {
					this.startTime = 0;
					this.endTime = 0;
					this.fetchData(1, this.pageSize);
				} else {
					[this.startTime, this.endTime] = this.value;
					// 将时间字符串转换为时间戳
					this.startTime = new Date(this.startTime).getTime();
					this.endTime = new Date(this.endTime).getTime();
					this.fetchData(1, this.pageSize);
				}
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			formatDate(timestamp) {
				const date = new Date(timestamp);
				// 获取年月日时分秒
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补0操作
				const day = date.getDate().toString().padStart(2, '0');
				const hours = date.getHours().toString().padStart(2, '0');
				const minutes = date.getMinutes().toString().padStart(2, '0');
				const seconds = date.getSeconds().toString().padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			riskConfig(level) { // 定义配置表，方便统一维护
				const safeLevel = (level === undefined || level === null) ? 4 : level;
				//3.代表直接封禁账户+封禁该手机（模拟器）继续使用APP；2代表直接阻断，封禁该账户；1代表有风险，但是你无法判断应不应该直接封号，交给人工进行二审；0代表该用户没有风险，可以正常使用。
				const configs = {
					4: {
						type: 'info', // 使用灰色，表示非业务性风险，而是系统未抓取到
						label: '-',
						icon: 'el-icon-warning-outline' // 使用空心图标，视觉上更“轻”
					},
					3: {
						type: 'danger',
						label: this.$t('language000496'), // 高风险
						icon: 'el-icon-error'
					},
					2: {
						type: 'warning',
						label: this.$t('language000495'), // 中风险
						icon: 'el-icon-warning'
					},
					1: {
						type: 'info',
						label: this.$t('language000494'), // 低风险
						icon: 'el-icon-info'
					},
					0: {
						type: 'success',
						label: this.$t('language000493'), // 正常
						icon: 'el-icon-success'
					}
				};
				// 如果 level 不在 0-3 之间，返回兜底配置
				return configs[safeLevel] || {
					type: '',
					label: '未知状态(' + level + ')',
					icon: 'el-icon-question'
				};
			},
			getGenderTagType(sex) {
				const types = {
					1: '',
					2: 'danger',
					3: 'warning',
					4: 'success',
					5: 'info'
				};
				return types[sex] || 'info';
			},
			// 结合你提到的颜色规范（如 red_100 等）
			getGenderCustomStyle(sex) {
				if (sex === 2) {
					return {
						backgroundColor: '#FEE2E2',
						color: '#EF4444'
					}; // 类似 red_100 的效果
				}
				if (sex === 3) {
					return {
						backgroundColor: '#FEF3C7',
						color: '#D97706'
					}; // 类似 amber_100 的效果
				}
				return {};
			},
			getType(level) {
				return this.riskConfig(level).type;
			},
			getText(level) {
				return this.riskConfig(level).label;
			},
			getIcon(level) {
				return this.riskConfig(level).icon;
			},
			isValid(level) {
				return [0, 1, 2, 3, 4].includes(level);
			}
			//...
		},
		//...
	}
</script>

<style>
	.container {
		display: flex;
		padding: 0px 10px;
	}

	.box {
		flex: 1;
		padding: 15px;
		width: 180px;
		height: 60px;
		margin: 10px;
		border-radius: 20px;
		/* 防止文本溢出 */
		overflow: hidden;
	}

	/* 强制表格主体容器始终显示纵向滚动条轨道 */
	::v-deep .el-table__body-wrapper {
		overflow-y: scroll !important;
	}

	/* 针对 Webkit 浏览器（Chrome/Edge）美化这个始终存在的滚动条 */
	::v-deep .el-table__body-wrapper::-webkit-scrollbar {
		width: 8px;
		/* 纵向滚动条宽度 */
		background-color: #f5f5f5;
		/* 轨道背景色，让它即便没滑块也看得见轨道 */
	}

	::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
		border-radius: 4px;
		background-color: #ccc;
		/* 滑块颜色 */
	}

	/* 解决表头与滚动条对不齐的问题（可选） */
	.el-table th.gutter {
		display: table-cell !important;
	}
</style>